import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '../../context/audienceInsights';
import { PublisherActions } from './PublisherActions';
import { PublisherNotifications } from './PublisherNotifications';
import { PublisherSelector } from './PublisherSelector';

export function PublisherSection() {
  const { t } = useTranslation();
  const { publishers, loading, error } = useAudienceInsights();

  const showContent = !loading && !!publishers;

  return (
    <FormSection divider title={t('Publisher')}>
      {loading && <Loader />}
      {error && <Alert severity="error">{t('Could not get publishers data from the server')}</Alert>}
      {showContent && (
        <Stack spacing={1}>
          <PublisherActions />
          <PublisherNotifications />
          {publishers.length > 0 && <PublisherSelector />}
        </Stack>
      )}
    </FormSection>
  );
}
